export const getAppUrl = (featureSearchType = 6) =>
  `/Application/get?featureSearchType=${featureSearchType}`;
export const getPharmacyServiceUrl = (pharmacyId, serviceId, searchType) =>
  `/ClinicalService/get-by-clinical-service-type?serviceID=${serviceId}&clinicalServiceStatusSearchType=${searchType}&pharmacyID=${pharmacyId}`;
export const getPharmacyClinicalServiceUrl = (pharmacyId) =>
  `/ClinicalService/get-clinical-service-list?pharmacyID=${pharmacyId}`;
export const getPharmacyClinicalServiceCountUrl = (pharmacyId) =>
  `/ClinicalService/get-clinical-service-count-list?pharmacyID=${pharmacyId}`;
export const getClinicalServiceBuilderByServiceIdUrl = (
  pharmacyId,
  serviceId,
) =>
  `/ClinicalServiceBuilder/get-clinical-service-Builder-by-service-type?serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const getClinicalServiceByCompanyAndServiceIdUrl = (
  companyID,
  serviceID,
) =>
  `/ClinicalServiceBuilder/get-clinical-service-by-company_service_id?companyID=${companyID}&serviceID=${serviceID}`;
export const getEventsUrl = (pharmacyId, serviceId) =>
  `/CalendarEvent/get-calendar-events-by-clinical-service-type-and-pharmacy-id?serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const updateEventUrl = () => "/CalendarEvent/update-calendar-event";
export const getAnalyticsByServicePharmacyDateUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-by-clinical-service-pharmacy-and-date?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAllDocumentsServiceUrl = (pharmacyId, serviceId) =>
  `/Document/list?serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const getTeamsRolesUrl = (companyId) =>
  `/Role/get?searchType=4&keyword=${companyId}`;
export const addRoleUrl = () => "/Role/add";
export const getTeamsRoleByIdUrl = (roleId) =>
  `/Role/get?searchType=2&keyword=${roleId}`;
export const getRolesUrl = (roleType) =>
  `/Role/get?searchType=1&keyword=''&roleType=${roleType}`;
export const getPermissionsUrl = () =>
  `/Role/get-permissions?searchType=1&keyword=323c4288-6cb9-495a-b42c-f8b0cb9f2b47`;
export const updateRoleUrl = () => `/Role/update`;
//clinicalChecksURL start here
export const getPrescriptionIncomingIdsUrl = (pharmacyId, teamId) =>
  `/Prescription/get-incoming-ids?pharmacyID=${pharmacyId}&teamID=${teamId}`;
export const getPrescriptionByIncomingIdUrl = (incomingId, pharmacyId) =>
  `/Prescription/get-prescription-by-incoming?incomingID=${incomingId}&pharmacyID=${pharmacyId}`;
export const getAutomationSummaryUrl = (prescriptionIncomingId, pharmacyId) =>
  `/Prescription/automation-summary?pharmacyID=${pharmacyId}&prescriptionIncomingId=${prescriptionIncomingId}`;
export const getMedicationUrl = (patientId, pharmacyId) =>
  `/PatientMedication/medication-check?patientID=${patientId}&pharmacyID=${pharmacyId}`;
export const getPrescriptionItemChecksUrl = (pharmacyId) =>
  `/Prescription/post-prescription-item-checks?pharmacyID=${pharmacyId}`;
export const getPrescriptionChecksUrl = (pharmacyId) =>
  `/Prescription/post-prescription-checks?pharmacyID=${pharmacyId}`;
export const postMedicationUrl = (pharmacyId) =>
  `/PatientMedication/add?pharmacyID=${pharmacyId}`;
export const getAdditionalEndorsementUrl = (prescribedItemId, pharmacyId) =>
  `/Prescription/get-additional-info?prescribedItemID=${prescribedItemId}&pharmacyID=${pharmacyId}`;
export const setPatientClinicalChecksUrl = (pharmacyId) =>
  `/Prescription/post-prescription?pharmacyID=${pharmacyId}`;
export const getPatientImageUrl = (imageValue, pharmacyId) =>
  `/Prescription/get-prescription-image?pharmacyID=${pharmacyId}&imageURL=${encodeURIComponent(imageValue)}`;
export const addEmergencySuppliesUrl = (
  pharmacyId,
  patientID,
  prescribedItemID,
) =>
  `/Prescription/reconcile-emergency-supplies?pharmacyID=${pharmacyId}&patientID=${patientID}&prescribedItemID=${prescribedItemID}`;
//clinicalChecksURL end here
export const documentSaveUrl = () => "/Document/save";
export const getDocumentById = (documentId) =>
  `/Document/get-by-id?documentID=${documentId}`;
export const inviteTeamMemberUrl = (teamId) =>
  `/Teams/invite-member?teamID=${teamId}`;
export const inviteMemberMultipleTeamsUrl = () =>
  `/Teams/invite-members-multiple-teams`;
export const addTeamUrl = () => `/Teams/save-team`;
export const updateTeamUrl = () => `/Teams/update-team`;
export const getTeamsUrl = () => `/Teams/get-teams?searchType=6`;
export const getUserImagesUrl = (teamId) =>
  `/Teams/get-User-by-teamid?teamID=${teamId}&joiningStatus=1`;
export const getGeneralsUrl = (companyId) =>
  `/Company/get-user-company?companyId=${companyId}`;
export const updateGeneralsDetailsUrl = () => "/Company/update";
export const getPharmaciesByCompanyIdUrl = (companyId) =>
  `/Pharmacies/get-pharmacy?searchType=3&keyword=${companyId}`;
export const getPharmacyByPharmacyIdUrl = (pharmacyId) =>
  `/Pharmacies/get-pharmacy?searchType=5&keyword=${pharmacyId}`;
export const getServicesByPharmacyIdUrl = (pharmacyId) =>
  `/Pharmacies/get-services?pharmacyID=${pharmacyId}`;
export const addRooms = () => "/Pharmacies/add-pharmacy-room";
export const updateRooms = () => "/Pharmacies/update-pharmacy-room";
export const getTemplatesUrl = (companyId) =>
  `/ClinicalServiceBuilder/get-templates-by-company?companyID=${companyId}`;
export const saveTemplateUrl = () => "/ClinicalServiceBuilder/add-template";
export const addOrbitSessionUrl = () => "/UserSessions/add-Sessions";
export const updateOrbitSessionUrl = () => "/UserSessions/update-userSession";
export const getClinicalServiceByClinicalServiceIdUrl = (clinicalServiceId) =>
  `/ClinicalService/get-multiple?clinicalServiceID=${clinicalServiceId}`;
export const getClinicalServiceUrl = (pharmacyId, isOrbitUser) =>
  `/ClinicalService/get-random-by-clinical-service-type?serviceCode=1&pharmacyID=${pharmacyId}&isOrbitUser=${isOrbitUser}`;
export const getClinicalServiceFromOrbitUrl = (
  serviceCode,
  sessionId,
  isTestMode,
  isAgencyUser,
) =>
  `/ClinicalService/get-orbit-by-priority?serviceCode=${serviceCode}&userSessionId=${sessionId}&isTestMode=${isTestMode}&isAgencyUser=${isAgencyUser}`;
export const getTitanPatientUrl = (patientId, pharmacyId, clinicalServiceId) =>
  `/Patient/get-titan-patient?patientID=${patientId}&pharmacyID=${pharmacyId}&clinicalServiceID=${clinicalServiceId}`;
export const getTitanPatientPdsUrl = (pharmacyId, clinicalServiceId) =>
  `/Patient/get-pds?pharmacyID=${pharmacyId}&clinicalServiceID=${clinicalServiceId}`;
export const addNmsUrl = (isOrbitUser) =>
  `/ClinicalService/update?isOrbitUser=${isOrbitUser}`;
export const getFollowUpByServiceIdAndServiceTypeUrl = (
  serviceId,
  serviceType,
  stageNo,
) =>
  `/CalendarEvent/get-calendar-events-by-entity-Id-and-type?entityID=${serviceId}&entityType=${serviceType}&stageNo=${stageNo}`;
export const searchDrugUrl = () => `/Search/drug`;
export const searchPatientUrl = () => `/Search/patient`;
export const addFollowUpUrl = () => `/CalendarEvent/add-calendar-event`;
export const getMembersUrl = (companyId) =>
  `/User/get-company-users?companyID=${companyId}`;
export const getMembersUrlV2 = (companyId) =>
  `/User/get-company-users-v2?companyID=${companyId}`;
export const getMembersWithActiveAvailabilityUrl = (companyId) =>
  `/User/get-company-users-with-active-availability?companyID=${companyId}`;
export const getServicesUrl = () => `/Service/get`;
export const addMemberUrl = () => "/User/add-user";
export const updateMemberUrl = () => "/User/update-user";
export const updateMemberUrlV2 = () => "/User/update-user-v2";
export const getMemberByIdUrl = (memberId) =>
  `/User/get-by-email?userEmail=${memberId}`;
export const saveServiceUrl = () => `/Service/add`;
export const updateServiceUrl = () => `/Service/update`;
export const getServiceTypeByIdUrl = (serviceTypeId) =>
  `/Service/get-by-id?serviceID=${serviceTypeId}`;
export const addpharmacyServiceUrl = (pharmacyId) =>
  `/PharmacyService/add-pharmacy-service?pharmacyID=${pharmacyId}`;
export const getPharmacyIdForOrbitUserUrl = () => `/OrbitSession/get`;
export const getOrbitProfileUrl = () => `/OrbitProfile/get`;
export const saveOrbitProfileUrl = () => `/OrbitProfile/save`;
export const addOrbitAuditUrl = (actionType, actionDate) =>
  `/OrbitAudit/save?actionType=${actionType}&actionDate=${actionDate}`;
export const getOrbitAuditBySessionIdUrl = (searchType, keyword) =>
  `/OrbitAudit/get?searchType=${searchType}&keyword=${keyword}`;
export const getOrbitDashboardUrl = () =>
  "/OrbitDashboard/get-by-orbit-dashboard-by-userEmail";
export const getVoiceJWTUrl = (pharmacyId) =>
  `/Voice/voice-jwt?pharmacyID=${pharmacyId}`;
export const sendSMSUrl = () => "/SMS/send";
export const getSMSUrl = () => "/SMS/get?searchType=1";
export const getConsentDataUrl = (searchType, keyword) =>
  `/SMS/get?searchType=${searchType}&keyword=${encodeURIComponent(keyword)}`;
export const addTimelineUrl = () => `/ClinicalService/add-timeline`;
export const addTimelineItemUrl = () => `/ClinicalService/add-timeline-item`;
export const getOrbitSessionDetailUrl = (pharmacyId) =>
  `/OrbitSession/get-orbit-session-rate?pharmacyID=${pharmacyId}`;
export const saveOrbitSessionDetailUrl = () => "/OrbitSession/save";
export const saveConsentFormUrl = (serviceId) =>
  `ClinicalService/update-clinical-service-by-serviceId`;
export const getUserLogUrl = (serviceId) =>
  `/ClinicalService/get-clinical-service-user-log-by-ClinicalServiceId?clinicalServiceID=${serviceId}`;
export const getTimelineUrl = (clinicalServiceID) =>
  `/ClinicalService/get-timeline?clinicalServiceID=${clinicalServiceID}`;
export const savePatientContactUrl = (serviceId, telephone) =>
  `ClinicalService/update-telephone?clinicalServiceID=${serviceId}&telephone=${telephone}`;
export const getIdentityVerificationUrl = () =>
  "/IdentityVerification/get-session-detail";
export const getIdentityVerificationDataBySessionIdUrl = (
  sessionId,
  gphcNumber,
) =>
  `/IdentityVerification/get-data-by-sessionId?sessionID=${sessionId}&gphcNumber=${gphcNumber}`;
export const getRecordingByConversationIdUrl = (conversationId) =>
  `/Voice/get-recording?conversationID=${conversationId}`;
export const getUserDataUrl = (userEmail) =>
  userEmail === null ||
  userEmail === undefined ||
  userEmail === "null" ||
  userEmail === "undefined" ||
  userEmail === ""
    ? `/User/get-by-email`
    : `/User/get-by-email?userEmail=${userEmail}`;
export const updateUserByUserEmailUrl = (userEmail) =>
  `/User/update-user-by-Email?userEmail=${userEmail}`;
export const updateIsActiveByUserEmailUrl = (userEmail, code) =>
  `/User/update-isActive-by-Email?userEmail=${userEmail}&code=${code}`;
export const updateIsActiveByUserEmailUrlCode = (code) =>
  `/Pharmacies/add-pharmacy-by-activation-code?activationCode=${code}`;
export const saveTotalAttemptsUrl = (clinicalServiceId, stageIndex) =>
  `/ClinicalService/add-total-attemtps-by-clinicalServiceId?clinicalServiceId=${clinicalServiceId}&stageIndex=${stageIndex}`;
export const addServiceNotesURL = () => `/ClinicalServiceNotes/add`;
export const getServiceNotesURL = (clinicalServiceId, stageType) =>
  `/ClinicalServiceNotes/get-notes-list?clinicalServiceID=${clinicalServiceId}&stageType=${stageType}`;
export const updateCalendarEventByClinicalServiceIdUrl = (
  rescheduleDate,
  clinicalServiceId,
  stageNo,
) =>
  `/CalendarEvent/update-calendar-event-by-ClinicalServiceId?rescheduleDate=${rescheduleDate}&clinicalServiceID=${clinicalServiceId}&stageNo=${stageNo}`;
export const updateRecheduleByClinicalServiceIdUrl = (
  rescheduleDate,
  clinicalServiceId,
  stageNo,
) =>
  `/ClinicalServiceNotes/add-reschedule?rescheduleDate=${rescheduleDate}&clinicalServiceID=${clinicalServiceId}&stageNo=${stageNo}`;
export const updateIsVerifyByUserEmailUrl = (userEmail) =>
  `/User/update-isVerify-by-Email?userEmail=${userEmail}`;
export const getServiceProgressURL = (serviceId, pharmacyId) =>
  `/ClinicalService/get-service-progress-by-serviceId?serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const getPatientByTelephoneAndStageIndexUrl = (
  telephone,
  value,
  serviceId,
  isOrbitUser,
) =>
  `/ClinicalService/get-patients-by-telephoneNumber?telephone=${telephone}&stageIndex=${value}&clinicalServiceID=${serviceId}&isOrbitUser=${isOrbitUser}`;
export const updateClaimStatusURL = () => `/Analytics/update-claim-status`;
export const sendToOrbitURL = () => `/OrbitQueue/send`;
export const getEmailByInvitationCodeUrl = (invitationCode) =>
  `/User/get-email-by-invitationCode?invitationCode=${invitationCode}`;
export const getInviteMemberLogsUrl = () => `/User/get-invite-member-logs`;
export const getUserForOrbitUrl = () => `/User/get-user-for-orbit`;
export const resendEmailToUserUrl = (userEmail) =>
  `/User/resend-email-to-user?userEmail=${userEmail}`;
export const userChangePasswordUrl = (userEmail) =>
  `/User/user-change-password?userEmail=${userEmail}`;
export const changeSentToOrbitUrl = (serviceId) =>
  `ClinicalService/update-sent-to-orbit?clinicalServiceID=${serviceId}`;
export const removeTeamMemberURL = (teamID, teamMemberID) =>
  `/Teams/remove-team-member?teamID=${teamID}&teamMemberID=${teamMemberID}`;
export const updateTotalAttemptsByClinicalServiceIdIrl = (serviceId) =>
  `/OrbitQueue/update-total-orbit-attempts-by-clinicalServiceId?clinicalServiceID=${serviceId}`;
export const getOrbitMonthlyReportUrl = (startDate, endDate) =>
  `/OrbitDashboard/get-monthly-report?startDate=${startDate}&endDate=${endDate}`;
export const getOrbitEarningsUrl = (startDate, endDate) =>
  `/OrbitDashboard/get-orbit-earnings?startDate=${startDate}&endDate=${endDate}`;
export const getOrbitUserSessionsUrl = () =>
  `/OrbitDashboard/get-user-sessions`;
export const getOrbitFollowUpServicesUrl = () =>
  `/OrbitDashboard/get-followup-services`;
export const getOrbitPotentialEarningsUrl = () =>
  `/OrbitDashboard/get-potential-earnings`;
export const getOrbitOtherDetailsUrl = () =>
  `/OrbitDashboard/get-other-details`;
export const userChangeCompanyUrl = (email, type, companyId) =>
  `/User/user-change-company?userEmail=${email}&userCompanyChangeType=${type}&companyId=${companyId}`;
export const getCompanyNamesUrl = (oldCompanyId, newCompanyId) =>
  `/Company/get-company-names?oldCompanyID=${oldCompanyId}&newCompanyID=${newCompanyId}`;
export const skipOrbitByClinicalServiceIdUrl = (
  clinicalServiceId,
  sessionId,
  isAgencyUser,
) =>
  `/OrbitQueue/skip-orbit-by-clinicalServiceId?clinicalServiceID=${clinicalServiceId}&userSessionID=${sessionId}&isAgencyUser=${isAgencyUser}`;
export const backOrbitByClinicalServiceIdUrl = (serviceId) =>
  `/OrbitQueue/back-orbit-by-clinicalServiceId?clinicalServiceID=${serviceId}`;
export const parkOrbitByClinicalServiceIdUrl = (serviceId) =>
  `/OrbitQueue/park-orbit-by-clinicalServiceId?clinicalServiceId=${serviceId}`;
export const getOrbitParkedServicesUrl = (isTestMode) =>
  `/OrbitDashboard/get-parked-orbit?isTestMode=${isTestMode}`;
export const changeOrbitServiceStatusUrl = (serviceId, status) =>
  `/OrbitQueue/change-status-by-clinicalServiceId?clinicalServiceId=${serviceId}&status=${status}`;
export const getOrbitActiveServicesUrl = (sessionId, isTestMode) =>
  `/OrbitDashboard/get-active-services?userSessionId=${sessionId}&isTestMode=${isTestMode}`;
export const moveInterventionUrl = () =>
  "/ClinicalService/send-to-intervention";
export const getTotalSkipsUrl = (clinicalServiceId, sessionId) =>
  `/OrbitQueue/get-total-skips?clinicalServiceID=${clinicalServiceId}&userSessionID=${sessionId}`;
export const updateLastLoginByEmailUrl = () =>
  `/User/update-lastLogin-by-email`;
export const addTestModeServiceUrl = (telephone, numberOfScripts) =>
  `/KPI/add-test-mode-service?telephone=${telephone}&numberOfScripts=${numberOfScripts}`;
export const getXeroContact = () => `/Xero/get-contact`;
export const upsertXeroContactUrl = () => `/Xero/upsert-contact`;
export const getXeroInvoiceUrl = (invoiceID) =>
  `/Xero/get-invoice-url?invoiceID=${invoiceID}`;
export const updateUserCurrentStatusUrl = (statusType) =>
  `/User/update-user-status?statusType=${statusType}`;
export const updateLogoutByEmailUrl = () => `/User/update-logout-by-email`;
export const checkYotiDataBySessionIdUrl = (sessionId) =>
  `/IdentityVerification/check-yoti-data-by-sessionId?sessionID=${sessionId}`;
export const declineServicesUrl = () => "/ClinicalService/decline-services";
export const rescheduleServicesUrl = (rescheduleDate) =>
  `/ClinicalService/reschedule-services?rescheduleDate=${rescheduleDate}`;
export const getPharmacyActionsUrl = (pharmacyId) =>
  `/Pharmacies/get-pharmacy-actions?pharmacyID=${pharmacyId}`;
export const changePharmacyActionsUrl = (
  pharmacyId,
  pharmacyActionType,
  isAction,
) =>
  `/Pharmacies/change-pharmacy-action?pharmacyID=${pharmacyId}&pharmacyActionType=${pharmacyActionType}&isAction=${isAction}`;
export const getDefaultCompanyServiceUrl = (companyId) =>
  `/Service/get-default-company-service?companyID=${companyId}`;
export const getDefaultServicesByCompanyIdAndPharmacyIdUrl = (
  companyId,
  pharmacyId,
  appointmentDate,
) =>
  `/Service/get-default-company-service-by-companyID-and-pharmacyID?companyID=${companyId}&pharmacyID=${pharmacyId}&appointmentDate=${encodeURIComponent(
    // The API only accepts a full ISO date-time; turn "YYYY-MM-DD" into midnight UTC
    // of that same day so the date doesn't shift.
    /^\d{4}-\d{2}-\d{2}$/.test(appointmentDate)
      ? `${appointmentDate}T00:00:00.000Z`
      : appointmentDate,
  )}`;
export const getDefaultCompanyCheckListForPublicURL = (companyId) =>
  `/Service/get-default-company-service-checklist?companyID=${companyId}`;
export const getQRCheckListForService = (companyId, serviceId, pharmacyId) =>
  `/Service/get-qr-setup-checklist?companyID=${companyId}&serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const getClinicalServiceBuilderByIdUrl = (serviceId) =>
  `/ClinicalServiceBuilder/get-clinical-service-builder-by-service-id?serviceID=${serviceId}`;
export const getServiceTemplatesUrl = () =>
  "/ClinicalServiceBuilder/get-service-templates";
export const submitCustomTemplateUrl = (companyId, serviceId) =>
  `/ClinicalServiceBuilder/add-template-list?companyID=${companyId}&serviceID=${serviceId}`;
export const getPaymentDetailsUrl = () => `/OrbitProfile/get-payment-details`;
export const getEmailsAndSmsTemplatesUrl = (companyId) =>
  `/MessageTemplate/get-default-company-message-template?companyID=${companyId}`;
export const addEmailsAndSmsTemplatesUrl = () => `/MessageTemplate/add`;
export const updateEmailsAndSmsTemplatesUrl = () => `/MessageTemplate/update`;
export const getServicesByCompanyUrl = (companyId) =>
  `/Service/get-default-company-service?companyID=${companyId}`;
export const getDefaultServiceUrl = () => `/Service/get-default-service`;
export const duplicateServiceUrl = (serviceId, companyId) =>
  `/Service/duplicate-service?serviceId=${serviceId}&companyId=${companyId}`;
export const getClinicalServiceBuilderResponseUrl = (serviceId, companyId) =>
  `/ClinicalServiceBuilder/get-clinical-service-builder-response?serviceID=${serviceId}&companyID=${companyId}`;
export const submitClincalServiceBuilderUrl = () =>
  `/ClinicalServiceBuilder/update-save-clinical-service-builder`;
export const updatePrivateServiceUrl = (isOrbitUser, isAddPrescription) =>
  `/ClinicalService/update-private-service?isAddPrescription=${isAddPrescription}&isOrbitUser=${isOrbitUser}`;
export const getClinicalServiceBuilderByCompanyIdUrl = (companyId) =>
  `/ClinicalServiceBuilder/get-clinical-service-by-compnay_id?companyID=${companyId}`;
export const updateClinicalServicePaymentDetailsUrl = (
  clinicalServiceId,
  isPaymentTaken,
) =>
  `/ClinicalService/update-clinical-service_payment_taken?clinicalServiceId=${clinicalServiceId}&isPaymentTaken=${isPaymentTaken}`;
export const getPatientPhoneNumberUrl = (clinicalServiceId, patientId) =>
  `/ClinicalService/get-patient-phoneNumber-by-patientId-and-clinicalServiceId?PatientID=${patientId}&clinicalServiceID=${clinicalServiceId}`;
export const changeMemberRoleUrl = () => `/User/change-role`;
export const moveDeclineServiceToClinicalServiceUrl = (clinicalServiceId) =>
  `/ClinicalService/move-decline-service-to-clinicalService?clinicalServiceID=${clinicalServiceId}`;
export const getOrbitTeamByCompanyId = (companyId) =>
  `/Teams/get-teams-by-company-id?companyID=${companyId}`;
export const getPrescriptionImagesByIncomingIdsUrl = (pharmacyId) =>
  `/Prescription/get-prescription-images-by-incomingIds?pharmacyID=${pharmacyId}`;
export const getOrbitAgencyUsers = (companyId) =>
  `/OrbitDashboard/get-agency-users?companyID=${companyId}`;
export const getOrbitAgencyDetails = (companyId) =>
  `/OrbitDashboard/get-agency-details?companyID=${companyId}`;
export const getOrbitAgencyTimeAndCompleted = (companyId) =>
  `/OrbitDashboard/calculate-agency-data?companyID=${companyId}`;
export const getAgencyRatesUrl = () => "/Agency/get-agencies-and-rate";
export const getAgencyPharmacyUrl = (pharmacyId) =>
  `/Agency/get-agency-pharmacy-by-pharmacyid?pharmacyID=${pharmacyId}&workLoadType=1`;
export const addAgencyPharmacyUrl = () => `/Agency/add-agency-pharmacy`;
export const getDefaultTemplatesUrl = (actionType) =>
  `/MessageTemplate/get-default-message-template-by-action?actionType=${actionType}`;
export const getAgencyPharmacies = (companyId, workLoadType) =>
  `/Agency/get-agency-pharmacies?companyID=${companyId}&workLoadType=${workLoadType}`;
export const getAgencyOtherPharmacies = (companyId, workLoadType) =>
  `/Agency/get-agency-pharmacies-other-available?companyID=${companyId}&workLoadType=${workLoadType}`;
// optimize analytics tabs
export const getAnalyticsNMSProcessedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-processed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAnalyticsServicesEarningsUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-earnings?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAnalyticsServicesUsersUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-users?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAnalyticsServicesStagesUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-stages?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAnalyticsServicesCompletedClaimedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-completed-claimed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getAnalyticsServicesCompletedToBeClaimedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
  filterType,
) =>
  `/Analytics/get-analytics-completed-to-be-claimed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`;
export const getAnalyticsServicesDeclinedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/Analytics/get-analytics-declined?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;

export const getOrbitAgencyMonthlyReport = (companyId, startDate, endDate) =>
  `/OrbitDashboard/get-monthly-report-orbit?companyID=${companyId}&startDate=${startDate}&endDate=${endDate}`;
export const getOrbitServicesWorkPlannerUrl = (companyId) =>
  `/OrbitDashboard/get-services-for-work-planner?companyID=${companyId}`;
export const getOrbitPharmanautsWorkPlannerUrl = (companyId) =>
  `/OrbitDashboard/get-pharmanauts-for-work-planner?companyID=${companyId}`;
export const getOrbitWorkPlannerUrl = (companyId) =>
  `/OrbitDashboard/get-work-planner-data?companyID=${companyId}`;
export const getUserByEmail = (email) =>
  `/User/get-user-by-email-for-orbitdashboard?userEmail=${email}`;
export const getOrbitAgencyServicesByCompanyId = (companyId) =>
  `Service/get-services-by-CompnayID?companyID=${companyId}`;
export const SaveOrbitPharmanautServices = () => `/User/update-user-services`;
export const getOthersAvailable = () => `/OrbitDashboard/get-others-available`;
export const addExclusivePharmacy = (companyId) =>
  `/OrbitDashboard/add-exclusive-pharmacy?companyID=${companyId}`;
export const postItemToolTipUrl = (pharmacyId) =>
  `/Prescription/get-item-tool-tip?pharmacyID=${pharmacyId}`;
export const updateItemToolTipUrl = (pharmacyId) =>
  `/Prescription/tool-tip-update-order?pharmacyID=${pharmacyId}`;
export const getPhamraciesNmsMetricsUrl = () =>
  `/PharmacyNmsMetrics/get-pharmacies-nms-metrics`;
export const getTravelInformationUrl = (clinicalServiceID) =>
  `/GeoLocation/get-travel-information?clinicalServiceID=${clinicalServiceID}`;
export const getDrugSearchUrl = (keyword) => `/Drug/search?keyword=${encodeURIComponent(keyword)}`;
export const getDrugInformationUrl = (prescribedItemId) =>
  `/Drug/get-drugs-information-by-prescribed-item-id?prescribedItemId=${prescribedItemId}`;
export const getProductByPrescriptionIdUrl = (prescribedItemId) =>
  `/Drug/get-product-by-prescriptionId?prescribedItemId=${prescribedItemId}`;
export const getCompletedTravelInformationUrl = (clinicalServiceID) =>
  `/ClinicalService/get-completed-travel-info?clinicalServiceID=${clinicalServiceID}`;
export const getCompletedClinicalServiceUrl = (clinicalServiceID) =>
  `/ClinicalService/get-completed-clinicalService?clinicalServiceID=${clinicalServiceID}`;
export const generatePrescriptionUrl = () =>
  `/Prescription/generate-prescription`;
export const addpatientInTitanUrl = (pharmacyId) =>
  `/Patient/add-patient-in-titan?pharmacyID=${pharmacyId}`;
export const getDrugUomFixValueUrl = (
  prescribedItemID,
  prescriptionOriginCountry,
  pharmacyID,
) =>
  `/Prescription/get-drug-uom-fix-value?prescribedItemID=${prescribedItemID}&prescriptionOriginCountry=${prescriptionOriginCountry}&pharmacyID=${pharmacyID}`;
export const getTitanPatientSearchUrl = (pharmacyId) =>
  `/Patient/get-titan-patient-search?pharmacyID=${pharmacyId}`;
export const deleteEmailsAndSmsTemplatesUrl = () =>
  `/MessageTemplate/archive-sms-email-template`;
export const getPharmacyProductsUrl = (pharmacyId) =>
  `/Pharmacies/get-pharmacy-product?pharmacyID=${pharmacyId}`;
export const updateItemToolTipFlavoursUrl = (pharmacyId) =>
  `/Prescription/tool-tip-update-order-flavours?pharmacyID=${pharmacyId}`;
export const getKanbanInboxUrl = (pharmacyId) =>
  `/ClinicalChecks/get-kanban-inbox?pharmacyID=${pharmacyId}`;
export const getKanbanCheckUrl = (pharmacyId) =>
  `/ClinicalChecks/get-kanban-check?pharmacyID=${pharmacyId}`;
export const addVaccineDosageUrl = (clinicalServiceID) =>
  `/VaccinationsDosage/add-vaccination-dosage?clinicalServiceID=${clinicalServiceID}`;
export const getVaccineInfoUrl = (clinicalServiceID) =>
  `/VaccinationsDosage/get-vaccine-info-by-clinicalServiceId?clinicalServiceID=${clinicalServiceID}`;
export const generatePatientPrescriptionUrl = () =>
  `/PatientEngagement/generate-patient-prescription`;
export const getTitanPatientByPatientIDUrl = (patientId, pharmacyId) =>
  `/Patient/get-titan-patient-by-patient-Id?patientID=${patientId}&pharmacyID=${pharmacyId}`;
export const getClinicalChecksTags = (pharmacyId) =>
  `/Tag/get-tag-lists?pharmacyID=${pharmacyId}`;
export const setPatientTagsUrl = (pharmacyId, patientId, tagId) =>
  `/Tag/set-patient-tags?pharmacyID=${pharmacyId}&patientID=${patientId}&tagID=${tagId}`;
export const lockedPrescriptionsUrl = (pharmacyId) =>
  `/Prescription/prescription-lock?pharmacyID=${pharmacyId}`;
export const getScheduleEventsUrl = (pharmacyId) =>
  `/ScheduleEvents/get-schedule-events-by-pharmacyid?pharmacyID=${pharmacyId}`;
export const getScheduleEventsByPharmaciesUrl = () =>
  `/ScheduleEvents/get-schedule-events-by-pharmacies`;
export const getResourcesUrl = (companyID, pharmacyId) =>
  `/ScheduleEvents/get-resources?companyID=${companyID}&pharmacyID=${pharmacyId}`;
export const getAllPharmacistsUrl = (companyID, pharmacyId) =>
  `/ScheduleEvents/get-all-resources?companyID=${companyID}&pharmacyID=${pharmacyId}`;
export const addScheduleEventUrl = (pharmacyId) =>
  `/ScheduleEvents/add-schedule-events?pharmacyID=${pharmacyId}`;
export const addBlockOutUrl = (pharmacyId) =>
  `/ScheduleEvents/add-block-events?pharmacyID=${pharmacyId}`;
export const getUsrAvailibilityUrl = (userEmail, serviceID, pharmacyId) =>
  `/ScheduleEvents/get-users-availability-by-user-email?userEmail=${userEmail}&serviceID=${serviceID}&pharmacyID=${pharmacyId}`;
export const getUsersAvailabilityByPriorityUrl = (
  companyID,
  serviceID,
  pharmacyID,
) =>
  `/ScheduleEvents/get-users-availability-by-priority-by-companyid-pharmacyid-and-serviceid?companyID=${companyID}&serviceID=${serviceID}&pharmacyID=${pharmacyID}`;
export const getScheduleEventsByCompanyUrl = () =>
  `/ScheduleEvents/get-schedule-events-by-company`;
export const saveGoogleEventsUrl = () => `/GoogleEvents/save-google-events`;
export const getGoogleEventsUrl = (companyID, pharmacyID) =>
  `/GoogleEvents/get-google-events?companyID=${companyID}&pharmacyID=${pharmacyID}`;
export const saveUserSettingsUrl = () => `/UserSettings/save-user-settings`;
export const getUserDefaultCalendarViewUrl = (companyId) =>
  `/UserSettings/get-user-default-calendar-view?companyId=${companyId}`;
export const getAllUserWeekAvailabilityUrl = () =>
  `/User/get-all-user-week-availability`;
export const getUserCompletedNmsUrl = (userEmail) =>
  `/ClinicalService/get-user-completed-nms?userEmail=${userEmail}`;
export const updateBucketStatusUrl = (
  pharmacyId,
  batchId,
  prescriptionIncomingId,
  bucketStatus,
) =>
  `/ClinicalChecks/update-bucket-status?pharmacyID=${pharmacyId}&batchId=${batchId}&prescriptionIncomingId=${prescriptionIncomingId}&bucketStatus=${bucketStatus}`;
export const updatePrescriptionPositionUrl = (pharmacyId) =>
  `/ClinicalChecks/update-prescription-position?pharmacyID=${pharmacyId}`;
export const deletePatientTagUrl = (pharmacyId, patientId, tagId) =>
  `/ClinicalChecks/delete-patient-tag?pharmacyID=${pharmacyId}&patientID=${patientId}&tagID=${tagId}`;
export const getPharmacyMetricThresholdUrl = (pharmacyId) =>
  `/PharmacyMetricThreshold/get-pharmacy-metric-threshold?pharmacyId=${pharmacyId}`;
export const getOrbitOwnerDashboardReports = () => `/Report/get-reports`;
export const getReportByIdUrl = (reportId, startDate, endDate, companyID) =>
  `/Report/get-report?reportId=${reportId}&startDate=${startDate}&endDate=${endDate}&companyID=${companyID}`;
export const approvePharmacyNmsRequestUrl = () =>
  `OrbitDashboard/approve-pharmacy-nms-request`;
export const cancelPharmacyNmsRequestUrl = () =>
  `OrbitDashboard/cancel-pharmacy-nms-request`;
export const updateUserExclusiveStatusUrl = (userEmail, isExclusive) =>
  `/OrbitDashboard/update-exclusive-user-status?userEmail=${userEmail}&exclusiveUser=${isExclusive}`;
export const getPatientHistoryUrl = (pharmacyId, patientId, fromDate, toDate) =>
  `/Patient/get-history?pharmacyID=${pharmacyId}&patientID=${patientId}&fromDate=${fromDate}&toDate=${toDate}`;
export const getOrbitLiveNmsUrl = (companyId) =>
  `/OrbitDashboard/get-agency-live-nms?companyID=${companyId}`;
export const sendToAgencyOrbitURL = () => `/OrbitQueue/send-agency-orbit`;
export const getPatientListUrl = (pharmacyId) =>
  `/Patient/get-patient-by-pharmacy-Id?pharmacyID=${pharmacyId}`;
export const addNewPatientUrl = () => `/Patient/add-patient-details`;
export const addNewPatientMatchUrl = () => `/Patient/add-patient-details-match`;
export const sendAIQAURL = () => `/Ai/qa`;
export const getPhamracyNmsMetricUrl = (pharmacyId) =>
  `/PharmacyNmsMetrics/get-pharmacy-nms-metric?pharmacyID=${pharmacyId}`;
export const getAppointmentsByPatientIdUrl = (patientId) =>
  `/ScheduleEvents/get-upcoming-Appointments-By-PatientId?patientID=${patientId}`;
export const getPaymentAnalyticsByPatientIdUrl = (patientId) =>
  `/Payments/get-payment-analytics-by-patient-id?patientID=${patientId}`;
export const getDoseShortCodeListUrl = (pharmacyId) =>
  `Prescription/get-dose-short-code-list?pharmacyID=${pharmacyId}`;
export const generateAiTemplateUrl = () =>
  `/AiTemplateBuilder/generate-template`;
export const saveAiTemplateUrl = () => `/AiTemplateBuilder/save-template`;
export const getAiTemplateByCompanyIdUrl = (companyID) =>
  `/AiTemplateBuilder/get-ai-templates-by-companyid?companyID=${companyID}`;
export const getAiTemplateByIdUrl = (templateId) =>
  `/AiTemplateBuilder/get-ai-template-by-id?templateId=${templateId}`;
export const updateAiTemplateUrl = () => `/AiTemplateBuilder/update-template`;
export const getDrugBySearchUrl = () => `/Drug/search`;
export const addPrescriptionUrl = () => `Prescription/add-prescription-data`;
export const getPrescriptionByPatientIdUrl = (patientId) =>
  `/Prescription/get-prescription-by-patientId?patientId=${patientId}`;
export const generateSummaryUrl = () => `/Ai/generate-consultation-summary`;
export const generateSummaryReportPdfUrl = () =>
  `/Report/generate-summary-report-pdf`;
export const generateVaccinePdfUrl = () => `/Report/generate-vaccine-pdf`;
export const generateAnswerUrl = () => "/Ai/chat";
export const addPatientVitalsUrl = () => `/PatientVitals/add-patient-vitals`;
export const getPatientVitalsUrl = (patientId) =>
  `/PatientVitals/get-patient-vitals-by-patientId?patientID=${patientId}`;
export const getPatientLastDosageUrl = (
  pharmacyId,
  patientID,
  prescribedItemID,
) =>
  `Prescription/get-last-dosage-by-patientId?pharmacyID=${pharmacyId}&patientID=${patientID}&prescribedItemID=${prescribedItemID}`;
export const addTitanAiRaisedConcernDetailsUrl = (
  pharmacyId,
  prescriptionIncomingId,
) =>
  `/Prescription/add-titan-ai-raised-concern-details?pharmacyID=${pharmacyId}&prescriptionIncomingId=${prescriptionIncomingId}`;
export const withdrawTitanAiRaisedConcernUrl = (
  pharmacyId,
  prescriptionIncomingId,
  concernId,
) =>
  `/Prescription/withdraw-titan-ai-raised-concern?pharmacyID=${pharmacyId}&prescriptionIncomingId=${prescriptionIncomingId}&concernId=${concernId}`;
export const generateReferalLetterUrl = () => `/Ai/generate-referal-letter`;
export const addPatientAllergiesUrl = () =>
  `/PatientAllergies/add-patient-allergies`;
export const getPatientAllergiesUrl = (patientId) =>
  `/PatientAllergies/get-patient-allergies-by-patientId?patientID=${patientId}`;
export const generateAiServiceTemplateUrl = (prompt) =>
  `/Ai/generate-service-summary`;
export const addVaccineUrl = () => `/PatientVaccination/add-vaccination-data`;

export const addPatientConditionRelatedUrl = () =>
  `/PatientConditionRelated/add-patient-condition-related`;
export const getPatientConditionRelatedUrl = (patientId) =>
  `/PatientConditionRelated/get-patient-condition-related-by-patientId?patientID=${patientId}`;
export const addPatientMedicationUrl = () =>
  `/PatientMedication/add-patient-medication`;
export const getPatientMedicationUrl = (patientId) =>
  `/PatientMedication/get-patient-medications-by-patientId?patientID=${patientId}`;
export const getCompanyVaccineByCompanyIdUrl = (companyID) =>
  `/CompanyVaccine/get-company-vaccine-by-companyId?companyID=${companyID}`;
export const getUsersAvailabilityByPharmacyIdUrl = (pharmacyId) =>
  `/Appointment/get-users-availability-by-pharmacy-Id?pharmacyID=${pharmacyId}`;
export const savePatientAppointmentUrl = () =>
  `Appointment/save-patient-appointment-booking`;
export const getIntercomDetailUrl = () => `Application/get-intercom-detail`;
export const getPatientByKeywordUrl = (pharmacyId, keyword, companyId) =>
  `/Patient/get-patient-by-pharmacy-Id-and-patient-name?pharmacyID=${pharmacyId}&keyword=${encodeURIComponent(
    keyword,
  )}&companyID=${companyId}`;
export const updateConsultationActionsUrl = (ConsultationId) =>
  `/PatientConsultation/update-consultation-actions?consultationID=${ConsultationId}`;
export const addPatientConsultationUrl = () =>
  `/PatientConsultation/add-patient-consultation`;
export const addupdateConsultationSummaryUrl = (ConsultationId) =>
  `PatientConsultation/add-update-consultation-summary?consultationID=${ConsultationId}`;
export const updatePatientDetailsUrl = () => `Patient/update-patient-details`;
export const getPatientConsultationsUrl = (PatientID) =>
  `PatientConsultation/get-patient-consultation?patientID=${PatientID}`;
export const updateConsultationActionsV2Url = (ConsultationId) =>
  `/PatientConsultation/update-consultation-actions-new?consultationID=${ConsultationId}`;
export const deleteConsultationActionUrl = (
  consultationID,
  actionNumber,
  vaccineName,
) =>
  `/PatientConsultation/delete-consultation-action?consultationID=${consultationID}&actionNumber=${actionNumber}&vaccineName=${encodeURIComponent(
    vaccineName || "",
  )}`;
export const deletePrescriptionDraftUrl = (consultationID, actionNumber) =>
  `/PatientConsultation/delete-prescriptionDraft-action?consultationID=${consultationID}&actionNumber=${actionNumber}`;
export const generateChatBotReferalLetterUrl = () =>
  `/Ai/generate-referal-letter-Aibot`;
export const generateDemDxAssessmentsUrl = () =>
  `/Integration/demdx-assessments`;
export const deleteScheduleEventsUrl = (eventID, currentPharmacyId) =>
  `/ScheduleEvents/delete-schedule-events?eventID=${eventID}&pharmacyID=${currentPharmacyId}`;
export const getPatientByPatientIdUrl = (patientID) =>
  `/Patient/get-patient-by-patient-Id?patientID=${patientID}`;
export const deleteAiTemplateByIdUrl = (templateID) =>
  `/AiTemplateBuilder/delete-ai-template-by-Id?templateID=${templateID}`;
export const importPatientFromTitanUrl = () =>
  `/Patient/import-patient-from-titan-by-patient-Id`;
export const SaveDemDxLogsAndSummaryUrl = () =>
  `/Integration/service-completion-notes`;
export const saveAIChatMessageUrl = () =>
  `/PatientConsultation/update-consultation-chat`;
export const GetPatientVitalsSummaryByPatientIdUrl = (patientID) =>
  `/PatientVitals/get-patient-vitals-summary-by-patientId?patientID=${patientID}`;
export const updateConsultationStatusUrl = () =>
  `/PatientConsultation/update-consultation-status`;
export const addConsultationTemplateUrl = (ConsultationId) =>
  `/PatientConsultation/add-consultation-template?consultationID=${ConsultationId}`;
export const updateConsultationTemplateUrl = (ConsultationId) =>
  `/PatientConsultation/update-consultation-template?consultationID=${ConsultationId}`;
export const deleteRoleByIdUrl = () => `/Role/delete`;
export const getMarketPlaceAppsUrl = () => `/MarketApp/get-marketapps`;
export const createCompanyMarketAppUrl = () =>
  `/MarketApp/create-companymarketapp`;
export const deleteCompanyMarketAppUrl = () =>
  `/MarketApp/delete-companymarketapp`;
export const getCompanyMarketAppsUrl = (companyID) =>
  `/MarketApp/get-companymarketapp?companyID=${companyID}`;
export const getCompanyMarketAppsByCompanyIdUrl = (companyID) =>
  `/MarketApp/get-companymarketapp-by-Companyid?companyID=${companyID}`;
export const saveNewServiceUrl = () => `/Service/add-new-service`;
export const updateNewServiceUrl = () => `/Service/update-new-service`;
export const deleteNewServiceUrl = () => `/Service/delete-service`;
export const addPatientConsultationNotes = () =>
  `/PatientConsultation/add-update-consultation-notes`;
export const updatePatientVitalsUrl = (isDelete) =>
  `/PatientVitals/update-patient-vitals?isDelete=${isDelete}`;
export const addConsultationFeedbackUrl = () =>
  `/PatientConsultation/add-consultation-feedback`;
export const deletePatientAllergiesUrl = () =>
  `/PatientAllergies/delete-patient-allergies`;
export const deletePatientConditionRelatedUrl = () =>
  `/PatientConditionRelated/delete-patient-condition-related`;
export const deletePatientMedicationsUrl = () =>
  `/PatientMedication/delete-patient-medication`;
export const addUpdatedTranscriptionUrl = () =>
  `/PatientConsultation/add-update-transcription`;
export const addPatientConsentUrl = (ConsultationId) =>
  `/PatientConsultation/add-consultation-patient-consent?consultationID=${ConsultationId}`;
export const getServiceAppointmentsUrl = (ConsultationId) =>
  `/ServiceAppointment/get-service-appointment?consultationID=${ConsultationId}`;
export const addDeepGramTranscriptionUrl = () =>
  `/DeepgramLogs/add-deeepgram-transcriprion`;
export const deleteUserByIdUrl = (email) => `/User/delete?email=${email}`;
export const deleteTeamByIdUrl = (teamID) =>
  `/Teams/delete-team?teamID=${teamID}`;
export const getTeamsByCompanyIdUrl = (companyId) =>
  `/Teams/get-teams-by-company-id?companyID=${companyId}`;
export const GetPatientConsultationCountByCompanyIdUrl = (companyID) =>
  `/PatientConsultation/get-patient-consultation-count-by-company-id?companyID=${companyID}`;
export const UpdatePharmacyLocationUrl = () =>
  "/Pharmacies/update-pharmacy-location";
export const getPreConsultTemplateByCompanyIdUrl = (companyID) =>
  `/AiTemplateBuilder/get-pre-consult-templates-by-companyid?companyID=${companyID}`;
export const savePreConsultTemplateUrl = () =>
  `/AiTemplateBuilder/save-pre-consult-template`;
export const updatePreConsultTemplateUrl = () =>
  `/AiTemplateBuilder/update-pre-consult-template`;
export const deletePreConsultTemplateByIdUrl = (teamID) =>
  `/AiTemplateBuilder/delete-pre-consult-template-by-Id?templateID=${teamID}`;
export const getAddressInformationUrl = () =>
  `/GeoLocation/get-address-information`;
export const updateConsultationButtonStatusUrl = () =>
  `/PatientConsultation/update-button-status`;
export const updateConsentObtainedUrl = () =>
  `/PatientConsultation/update-consent-obtained`;
export const getRoomsUrl = (companyId) => `Room/get?companyID=${companyId}`;
export const getUsersByServiceIDUrl = (serviceID, companyId, pharmacyId) =>
  `/Service/get-users-by-serviceID-and-companyID?serviceID=${serviceID}&companyID=${companyId}&pharmacyID=${pharmacyId}`;
export const getUsersByServiceCompanyPharmacyIDUrl = (
  companyId,
  serviceId,
  pharmacyId,
) =>
  `/Service/get-users-by-serviceID-companyID-pharmacyID?companyID=${companyId}&serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
  export const getAvailablePharmacistsForServiceUrl = (
  companyId,
  serviceId,
  pharmacyId,
) =>
  `/Service/get-users-by-serviceID-companyID-pharmacyID-v2?companyID=${companyId}&serviceID=${serviceId}&pharmacyID=${pharmacyId}`;
export const getPharmacyAvailableSlotsUrl = () =>
  `/Pharmacies/get-pharmacy-available-slots`;
export const getActivePharmacistsUrl = () => `/Service/get-active-pharmacists`;
export const generatePreConsultAiTemplateUrl = () =>
  `/AiTemplateBuilder/generate-pre-consult-template`;
export const generatePreConsultAiServiceTemplateUrl = (prompt) =>
  `/Ai/generate-pre-consult-service-summary`;
export const addCertificateUrl = () => `/User/add-certificate`;
export const addUpdatePinCodeUrl = () => `/User/add-update-pincode`;
export const addDigitalSignatureUrl = () => `/User/add-digital-signature`;
export const deleteDigitalSignatureUrl = (userEmail) =>
  `/User/delete-digital-signature?userEmail=${userEmail}`;
export const getPatientPrescriptionsUrl = (companyID) =>
  `/Prescription/get-patient-prescriptions?companyID=${companyID}`;
export const updatePatientPrescriptionUrl = () =>
  `Prescription/update-patient-prescription`;
export const verifyPinForPrescriptionApprovalUrl = (pinCode) =>
  `/Prescription/verify-pin-for-prescription-approval?pinCode=${pinCode}`;
export const getUserCertificateUrl = () => `/User/get-user-certificate`;
export const getConsultationAuditTimelineUrl = (ConsultationId) =>
  `/PatientConsultationTimeline/get-consultation-timeline?consultationID=${ConsultationId}`;
export const addPatientDocumentUrl = () =>
  `/PatientDocument/add-patient-document`;
export const getPatientDocumentsUrl = (patientId) =>
  `/PatientDocument/get-documents-by-patientId?patientID=${patientId}`;
export const updateBlockOutUrl = (pharmacyId) =>
  `/ScheduleEvents/update-block-event?pharmacyID=${pharmacyId}`;
export const deleteBlockOutUrl = (eventID, currentPharmacyId) =>
  `/ScheduleEvents/delete-block-event?eventID=${eventID}&pharmacyID=${currentPharmacyId}`;
export const getDoctorsBySearchUrl = (searchText) =>
  `/Patient/get-doctors?searchText=${encodeURIComponent(searchText)}`;
export const getPatientConsultationByConsultationIdUrl = (consultationID) =>
  `PatientConsultation/get-patient-consultation-by-consultationId?consultationID=${consultationID}`;
export const patientPrescriptionBulkUpdateUrl = () =>
  `Prescription/patient-prescription-bulk-update`;
export const renamePatientDocumentUrl = () =>
  `/PatientDocument/rename-patient-document`;
export const emailPatientDocuments = () =>
  `/PatientDocument/send-patient-document-email`;
export const updateUserProfileUrl = () => `/User/update-user-profile`;
export const updateUserWeekAvailabilityUrl = () =>
  `/User/update-user-week-availability`;
export const deletePatientDocumentUrl = (documentID) =>
  `/PatientDocument/delete-document-by-id?documentID=${documentID}`;
export const getPatientDocumentByIdUrl = (documentID) =>
  `/PatientDocument/get-documents-by-Id?documentID=${documentID}`;
export const getPatientPrescriptionByIdUrl = (ID) =>
  `Prescription/get-patient-prescription-by-id?id=${ID}`;
export const getPatientVitalsChartsUrl = (patientId, vitalName) =>
  `/PatientVitals/get-patient-vitals-charts-by-patientId?patientID=${patientId}&vitalName=${encodeURIComponent(vitalName)}`;
export const getConsultationActionByActionIdUrl = (ConsultationId) =>
  `/PatientConsultation/get-action-by-consultationid?consultationID=${ConsultationId}`;
export const getPatientPrescriptionsByPatientIdUrl = (patientId) =>
  `/PatientPrescription/get-patient-prescription-by-patientId?patientID=${patientId}`;
export const getUsersProfileUrl = () => `/User/get-user-profile`;
export const addUserAccreditationUrl = () => `/User/add-user-accreditation`;
export const deleteUserAccreditationUrl = (accreditationID) =>
  `/User/delete-user-accreditation?accreditationId=${accreditationID}`;
export const viewUserAccreditationUrl = (accreditationID) =>
  `/User/get-user-accreditation?accreditationId=${accreditationID}`;
export const getPatientActiveConsultationUrl = (PatientID) =>
  `PatientConsultation/get-patient-active-consultation?patientID=${PatientID}`;
export const getPrescriptionByPrescriptionIDUrl = (prescriptionID) =>
  `/Prescription/get-patient-prescription-by-prescriptionid?prescriptionID=${prescriptionID}`;
export const addCompanyDocumentUrl = () =>
  `/CompanyDocument/add-company-document`;
export const getCompanyDocumentsByCompanyId = (companyID) =>
  `CompanyDocument/get-company-document-by-company-id?companyID=${companyID}`;
export const getDocumentsAnalyticsByCompanyId = (companyID) =>
  `CompanyDocument/get-documents-analytics-by-company-id?companyID=${companyID}`;
export const addCompanyFolderUrl = () => `/CompanyDocument/add-company-folder`;
export const renameCompanyFolderUrl = () =>
  `/CompanyDocument/rename-company-folder`;
export const getCompanyFoldersByCompanyIdUrl = (companyID) =>
  `/CompanyDocument/get-company-folder-by-company-id?companyID=${companyID}`;
export const getDocumentsOverallCompliancesByCompanyIdUrl = (companyID) =>
  `/CompanyDocument/get-documents-overall-compliance-by-company-id?companyID=${companyID}`;
export const getDocumentsMembersCompliancesByCompanyIdUrl = (companyID) =>
  `/CompanyDocument/get-documents-member-compliance-by-company-id?companyID=${companyID}`;
export const viewCompanyDocumentUrl = () =>
  `CompanyDocument/get-company-document`;
export const sendAhtWeightManagementEmailUrl = () =>
  `/Email/send-aht-weight-management-email`;
export const getAllDocumentsByEmailUrl = () =>
  `/CompanyDocument/get-user-compliance-document-by-email`;
export const updateEventStatusUrl = () => `/ScheduleEvents/update-event-status`;
export const getCompayDocumentById = (docId) =>
  `CompanyDocument/get-company-document-by-id?ID=${docId}`;
export const updateCompanyDocumentUrl = () =>
  `CompanyDocument/update-company-document`;
export const generateAiQuestionairesUrl = () =>
  `/CompanyDocument/generate-ai-questionaires-from-document`;
export const addorUpdateDocumentQuestionsUrl = () =>
  `/CompanyDocument/update-company-document-questions`;
export const UpdateDocumentcomplienceStatusUrl = () =>
  `/CompanyDocument/update-company-document-compliance-status`;
export const getCompanyTagsByCompanyIdUrl = (companyID) =>
  `/CompanyTags/get-company-tags-by-companyId?companyID=${companyID}`;
export const addCompanyTagsUrl = () => `/CompanyTags/add-company-tags`;
export const deleteCompanyTagsUrl = (tagId) =>
  `/CompanyTags/delete-company-tags?tagID=${tagId}`;
export const updateDocumentAssignmentsUrl = () =>
  `/CompanyDocument/update-company-document-assignments`;
export const UpdateMultipleDocumentcomplienceStatusUrl = () =>
  `/CompanyDocument/update-multiple-company-document-compliance-status`;
export const getPatientByDemoGraphicsUrl = (pharmacyId) =>
  `/Pds/get-patient-by-demographics?pharmacyID=${pharmacyId}&isTesting=${false}`;
export const getPatientByNhsNumberUrl = (pharmacyId) =>
  `/Pds/get-patient-by-nhs-number?pharmacyID=${pharmacyId}&isTesting=${false}`;
export const getAllCompanyDocumentsByCompanyId = (companyID) =>
  `CompanyDocument/get-all-company-document-by-company-id?companyID=${companyID}`;
export const getAnalyticsServicesCompletedToBeClaimedHisotryUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
  filterType,
) =>
  `/HistoricalAnalytics/get-analytics-completed-to-be-claimed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`;
export const getHistoryAnalyticsNMSProcessedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/HistoricalAnalytics/get-analytics-processed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const getHistoryAnalyticsServicesCompletedClaimedUrl = (
  pharmacyId,
  serviceId,
  startDate,
  endDate,
) =>
  `/HistoricalAnalytics/get-analytics-completed-claimed?pharmacyID=${pharmacyId}&serviceID=${serviceId}&startDate=${startDate}&endDate=${endDate}`;
export const SummarizeConsultationSammariesUrl = () =>
  `/Ai/summarize-consultations`;
export const trackServiceBillingUrl = () =>
  `/CompanyServiceBilling/track-service-billing`;
export const getTrackServiceBillingUrl = (companyId) =>
  `/CompanyServiceBilling/get-track-service-billing?companyID=${companyId}`;
export const getPatientCommunicationByPatientIdUrl = (patientId) =>
  `/PatientCommunication/get-patient-communication-by-patient-id?patientID=${patientId}`;
export const addNewPatientCommunicationUrl = () =>
  `/PatientCommunication/add-patient-communication`;
export const deletePatientCommunicationUrl = (ID) =>
  `/PatientCommunication/archive-patient-communication?ID=${ID}`;

export const getCompanySubscriptionsUrl = (companyId) =>
  `/CompanySubscription/get-company-subscription-by-company-id?companyID=${companyId}`;
export const GetCompanyLedgerSummaryUrl = (companyId) =>
  `/CompanyLedgers/get-company-ledger-summary?companyID=${companyId}`;
export const GetCompanyLedgerPurchaseHistoryUrl = (companyId) =>
  `/CompanyLedgers/get-company-ledger-purchase-history?companyID=${companyId}`;
export const addPromotionalCreditUrl = () =>
  `/CompanyLedgers/add-promotional-credit?isBackOffice=${false}`;
export const getDefaultMessageTemplateUrl = (companyID) =>
  `/MessageTemplate/get-default-template-by-company-id?companyID=${companyID}`;
export const getGoCardlessBillingRequestUrl = () =>
  `/GoCardless/BillingRequest`;
export const getCompanyInvoicesByCompanyIdUrl = (companyId) =>
  `/CompanySubscription/get-company-invoices-by-company-id?companyID=${companyId}`;
export const getAllDestinationsUrl = () => `/TravelDestinations/get-all`;
export const getTravelOutbreaksUrl = () => `/TravelOutbreaks/get-outbreaks`;
export const getSendPatientQuestionnairesUrl = () =>
  `/PatientQuestionnaires/send-pre-consult-questionnaire`;
export const updateCompanySubscriptionUrl = () =>
  `/CompanySubscription/update-company-subscription-user-packs`;
export const getCompnayUserCountUrl = (companyId) =>
  `/User/get-company-users-count?companyID=${companyId}`;
export const getPharmacyDashboardUrl = () =>
  `/PharmacyDashboard/get-pharmacy-dashboard`;
export const getScheduleEventsByUserUrl = (pharmacyID) =>
  `/PharmacyDashboard/get-schedule-events-by-user?pharmacyID=${pharmacyID}`;
export const getActiveConsultationsByUserUrl = (pharmacyID) =>
  `/PharmacyDashboard/get-active-cosultation-by-user?pharmacyID=${pharmacyID}`;
export const getPatientQuestionnairesByPatientyIdUrl = (patientId) =>
  `PatientQuestionnaires/get-by-patient-id?patientID=${patientId}`;
export const getConsultationForNHSEmergencyServiceUrl = (pharmacyId) =>
  `/NHSEmergency/get-consultation-for-nhs-emergency-service?pharmacyId=${pharmacyId}`;
export const checkAndAddConsultation = () =>
  `/PatientConsultation/check-and-add-consultation`;
export const startConsultationFromQuestionnaireUrl = () =>
  `/PatientConsultation/start-consultation-from-questionnaire`;
export const createAccountUrl = () => "/Payments/create-account";
export const createAccountLinkUrl = () => "/Payments/create-account-link";
export const getAccountRegisteredUrl = (email) =>
  `/Payments/get-account-registered?email=${email}`;
export const getCompaniesUrl = (searchType, keyword = "") =>
  `/Company/get-companies?searchType=${searchType}&keyword=${encodeURIComponent(keyword)}`;
export const getPatientsListUrl = (pharmacyId) =>
  `/Patient/get-patient-for-patient-list?pharmacyID=${pharmacyId}`;
export const SummarizeConsultationsActionsUrl = () =>
  `/Ai/summarize-consultations-actions`;
export const getPreConsultationByConsultationIdUrl = (consultationId) =>
  `/PatientConsultation/get-preconsult-by-consultationId?consultationID=${consultationId}`;
export const mergePatientDetailsUrl = () => `/Patient/merge-patient-details`;
export const getPatientConsultationCountByPatientIdUrl = () =>
  `/PatientConsultation/get-patient-consultation-count-by-patient-id`;
export const getDemDxDetailUrl = () => `Application/get-demdx-detail`;
export const getTotalRevenueTrendUrl = () =>
  `AnalyticsReport/get-services-total-revenue-trend`;
export const getAverageComplianceUrl = () =>
  `AnalyticsReport/get-services-average-compliance`;
export const getServiesPerformanceUrl = () =>
  `AnalyticsReport/get-services-performance`;
export const getTotalBookingsGrowthUrl = () =>
  `AnalyticsReport/get-services-total-bookings-growth`;
export const getAnalyticsReportsUrl = () => `AnalyticsReport/all`;
export const getAnalyticsPerformanceUrl = () =>
  `AnalyticsReport/get-members-performance`;
export const getMembersAvgComplianceUrl = () =>
  `AnalyticsReport/get-members-average-compliance`;
export const getPerformanceDistributionUrl = () =>
  `AnalyticsReport/get-members-performance-distribution`;
export const importMultipleFromTitanUrl = () =>
  `/Patient/multiple-import-patient-from-titan-by-patient-Id`;
export const getPatientsListV2Url = () =>
  `/Patient/get-patient-for-patient-list-V2`;
export const getRoomsForAppointmentUrl = () => `Room/get-rooms-for-appointment`;
export const getRoomsByServiceIdUrl = (serviceId, companyId, pharmacyId) =>
  `Room/get-rooms-by-service-id?companyID=${companyId}&pharmacyID=${pharmacyId}&serviceID=${serviceId}`;
export const getCompanyRoomsByServiceIdUrl = () =>
  `Room/get-company-rooms-by-service-id`;
export const deleteDigitalCertificateUrl = (userEmail) =>
  `/User/delete-digital-certificate?userEmail=${userEmail}`;
export const getAllAnalyticsReports = () => `/AnalyticsReport/all`;
export const deleteCompanyDocumentsUrl = () =>
  `/CompanyDocument/delete-company-documents`;
export const deleteCompanyFolderUrl = () =>
  `/CompanyDocument/delete-company-folder`;
export const getAnalyticsReportByIdUrl = (
  reportID,
  startDate,
  endDate,
  companyID,
  pharmacyID,
) =>
  `/AnalyticsReport/report?reportID=${reportID}&startDate=${startDate}&endDate=${endDate}&companyID=${companyID}&pharmacyID=${pharmacyID}`;
export const getPharmacyContactDetailsUrl = (pharmacyId) =>
  `/Pharmacies/get-pharmacy-contact-details?pharmacyID=${pharmacyId}`;
export const getPaymentAuditByConsultationUrl = (consultationID) =>
  `/Payments/get-payment-audit-by-consultationId?consultationID=${consultationID}`;
export const declinePrescriptionByIdUrl = () =>
  `/Prescription/decline-prescription-by-prescription-id`;
export const addPharmacyNotificationUrl = () =>
  `/PharmacyNotification/add-pharmacy-notification`;
export const getPharmacyNotificationsUrl = () =>
  `/PharmacyNotification/get-pharmacy-notifications`;
export const markNotificationsAsReadUrl = () =>
  `/PharmacyNotification/mark-notifications-as-read`;
export const markNotificationAsReadUrl = () =>
  `/PharmacyNotification/mark-notification-as-read`;
export const getPatientConsentSignatureUrl = () =>
  `/PatientConsultation/get-patient-consent-signature`;
export const getReferalLetterByFilePathUrl = () =>
  `/PatientConsultation/get-patient-referral-letter`;
export const getPatientDocumentsByConsultationUrl = (consultationId) =>
  `/PatientDocument/get-documents-by-consultationId?consultationID=${consultationId}`;
export const acceptTermsAndConditionsUrl = () =>
  `/CompanySubscription/accept-terms-and-conditions`;
export const getTermsAndConditionsPdfUrl = (fileName) =>
  `/CompanySubscription/download-terms-and-conditions?fileName=${encodeURIComponent(fileName)}`;
export const updateConsultationForPatientMatchUrl = () =>
  `/NHSEmergency/update-consultation-for-patient-match`;
export const getPatientForNHSEmergencyServiceUrl = (consultationID) =>
  `/NHSEmergency/get-patient-details-for-nhs-emergency-service?consultationID=${consultationID}`;
export const getServiceDetailsUrl = () =>
  `AnalyticsReport/get-service-analytics`;
export const updateConsultationStageUrl = () =>
  `/NHSEmergency/update-consultation-stage-for-nhs-emergency-service`;
export const getPendingInvitesUrl = (companyId) =>
  `/Teams/get-pending-invites-by-company?companyID=${companyId}`;
export const deleteInviteUrl = (inviteId) =>
  `/Teams/delete-invite?inviteId=${inviteId}`;
export const sendMessageToMeshUrl = () =>
  `/NHSConsultation/send-message-to-mesh`;
export const getServiceByServiceId = (serviceId) =>
  `/Dos/get-service-by-service-id?serviceId=${serviceId}`;
export const getPatientVaccinationByPatientIdUrl = (patientId) =>
  `/PatientVaccination/get-patient-vaccination-by-patientId?patientID=${patientId}`;
export const updatePatientEthnicityUrl = () =>
  `Patient/update-patient-ethnicity`;
export const generateVideoUploadUrlUrl = () =>
  `/PatientDocument/generate-video-upload-url`;
export const getPharmacyMetricThresholdByCompanyIdUrl = (companyID) =>
  `/PharmacyMetricThreshold/get-pharmacy-metric-threshold-by-companyid?companyId=${companyID}&metricDate=${encodeURIComponent(
    new Date().toISOString()
  )}`;
export const updatePharmacyMetricThresholdUrl = () =>
  `/PharmacyMetricThreshold/update-pharmacy-metric-thresholds`;
export const getCompanyMetricVisibilityUrl = (companyID) =>
  `/PharmacyMetricThreshold/get-company-metric-visibility?companyId=${companyID}`;
export const upsertCompanyMetricVisibilityUrl = () =>
  `/PharmacyMetricThreshold/upsert-company-metric-visibility`;
export const getServicesByPostCodeUrl = () => `/Dos/get-services-by-post-code`;

export const getCompanyProductRulesByCompanyIdUrl = (companyId) =>
  `/CompanyProductRules/get-by-companyId?companyID=${companyId}`;

export const addCompanyProductRuleUrl = () =>
  `/CompanyProductRules/add-product-rule`;

export const editCompanyProductRuleUrl = (prescribedItemId) =>
  `/CompanyProductRules/edit-product-rule?prescribedItemId=${prescribedItemId}`;

export const getProductRuleAuditUrl = (prescribedItemId, productRuleId) =>
  `/ProductRulesAudit/get-by-id?prescribedItemId=${prescribedItemId}&productRuleId=${productRuleId}`;

export const removeCompanyProductRuleUrl = (prescribedItemId, productRuleId) =>
  `/CompanyProductRules/remove-product-rule?prescribedItemId=${prescribedItemId}&productRuleId=${productRuleId}`;

export const searchProductDrugUrl = (keyword) =>
  `/Drug/search-product-drug?keyword=${encodeURIComponent(keyword)}`;

export const getMonthlyConcessionUrl = (concessionMonth) =>
  `/CompanyProductRules/get-monthly-concessions?concessionMonth=${encodeURIComponent(
    concessionMonth,
  )}`;

export const getHistoricalConcessionUrl = () =>
  `/CompanyProductRules/get-historical`;

export const addConcessionUrl = () => `/CompanyProductRules/add-concession`;

export const getDashboardStatsUrl = (companyId) =>
  `/GroupMode/get-dashboard-stats?companyID=${companyId}`;
export const getPharmacyPrivateServicesIncomeUrl = (
  companyId,
  pharmacyId,
  month,
) =>
  `/GroupMode/get-pharmacy-private-services-income?companyID=${companyId}&pharmacyId=${pharmacyId}&month=${month}`;
export const getPharmacyPrivateServicesIncomeByDateRangeUrl = (
  companyId,
  pharmacyId,
  startDate,
  endDate,
) =>
  `/GroupMode/get-pharmacy-private-services-income-by-date-range?companyID=${companyId}&pharmacyId=${pharmacyId}&startDate=${encodeURIComponent(
    startDate,
  )}&endDate=${encodeURIComponent(endDate)}`;
export const getDispensingIncomeUrl = (pharmacyId, fromDate, toDate) =>
  `/Finance/get-dispensing-income?pharmacyId=${pharmacyId}&fromDate=${encodeURIComponent(
    fromDate,
  )}&toDate=${encodeURIComponent(toDate)}`;
export const getPatientActiveTreatmentPlanUrl = (patientId) =>
  `/TreatmentPlan/get-active-treatment-plan-by-patientId?patientID=${patientId}`;
export const updateTreatmentPlanUrl = () =>
  `/TreatmentPlan/update-treatment-plan`;
export const checkRefreshStatusUrl = (companyId) =>
  `/PharmacyMetricThreshold/check-refresh-status?companyId=${companyId}`;
export const deleteTreatmentPlanActionUrl = () =>
  `/PatientConsultation/delete-treatment-plan-and-dependents`;
export const updateTaskActionStatusUrl = () =>
  `/PatientConsultation/update-task-action-status`;
export const refreshPharmacyMetricThresholdUrl = () =>
  `/PharmacyMetricThreshold/refresh-pharmacy-metric-threshold`;
export const completeConsultationHistoryUrl = () =>
  `/TreatmentPlan/complete-consultation-history`;
export const updateReferralSendActionsUrl = (ConsultationId) =>
  `/PatientConsultation/update-referral-send-actions?consultationID=${ConsultationId}`;
export const generateAITreatmentPlanUrl = () => `/Ai/generate-treatment-plan`;
export const linkAppointmentConsultationUrl = () =>
  `/TreatmentPlan/link-appointment-consultation`;
export const updateTreatmentPlanFollowUpStatus = () =>
  `/TreatmentPlan/update-treatmentplan-followup-status`;
export const addConsultationLinkedTemplateUrl = () =>
  `/ConsultationLinkedTemplate/add-consultation-linked-template`;
export const getConsultationLinkedTemplateByConsultationIdUrl = (
  consultationId,
) =>
  `/ConsultationLinkedTemplate/get-by-consultation-id?consultationId=${consultationId}`;
export const getConsultationLinkedTemplateByPatientIdUrl = (patientId) =>
  `/ConsultationLinkedTemplate/get-by-patient-id?patientID=${patientId}`;
export const createNmsClaimUrl = () => `/MysNms/create-claim`;
export const createContraceptionClaimUrl = () =>
  `/MysContraception/create-claim`;
export const updateServiceSortingUrl = () => `/Service/update-service-sorting`;
export const createClaimsAuditUrl = () => `/MysNms/create-claim`;
export const getMemberDetailsUrl = () =>
  `/AnalyticsReport/get-member-analytics`;
export const getCompanyPharmaciesCountUrl = (companyId) =>
  `/Pharmacies/get-company-pharmacies-count?companyID=${companyId}`;
export const UpdateCompanySubscriptionSiteLicensesUrl = () =>
  `/CompanySubscription/update-company-subscription-site-license`;
export const getCompanySubscriptionCostsUrl = (companySubscriptionType) =>
  `/CompanySubscription/get-company-subscription-type-unit-cost?companySubscriptionType=${companySubscriptionType}`;
export const addCompanySubscriptionUrl = () =>
  `/CompanySubscription/add-company-subscription-sitelicenses`;
export const removeServiceFromPharmacyUrl = () =>
  `/Pharmacies/remove-service-from-pharmacy`;
export const getReferralDataByConsultationIdUrl = (consultationId) =>
  `/NhsBar/get-referral-data-by-consultationId?consultationID=${consultationId}`;
export const getTitanClaimsUrl = (pharmacyId) =>
  `/Claims/get-claims?pharmacyId=${pharmacyId}`;
export const getPrescriptionImageUrl = (pharmacyId, incomingId) =>
  `/Claims/get-prescription-image?pharmacyId=${pharmacyId}&incomingId=${incomingId}`;
export const getItemInfoUrl = (pharmacyId) =>
  `/Claims/get-item-info?pharmacyId=${pharmacyId}`;
export const saveClaimsUrl = (pharmacyId) =>
  `/Claims/save-claims?pharmacyId=${pharmacyId}`;
export const processClaimUrl = (pharmacyId) =>
  `/Claims/process-claim?pharmacyId=${pharmacyId}`;
export const replacementDispenseNotificationUrl = (pharmacyId) =>
  `/Claims/replacement-dispense-notification?pharmacyId=${pharmacyId}`;
export const bulkRtecUrl = (pharmacyId) =>
  `/Claims/bulk-rtec?pharmacyId=${pharmacyId}`;
export const getClaimedCurrentUrl = (pharmacyId) =>
  `/Claims/get-claimed-current?pharmacyId=${pharmacyId}`;
export const getClaimedLastUrl = (pharmacyId) =>
  `/Claims/get-claimed-last?pharmacyId=${pharmacyId}`;
export const claimAmendmentUrl = (pharmacyId) =>
  `/Claims/claim-amendment?pharmacyId=${pharmacyId}`;
export const getBlockedClaimsUrl = (pharmacyId) =>
  `/Claims/get-blocked-claims?pharmacyId=${pharmacyId}`;
export const getFp34SummaryUrl = (pharmacyId, cycleMonth) =>
  `/Finance/get-fp34-summary?pharmacyId=${pharmacyId}${
    cycleMonth ? `&cycleMonth=${encodeURIComponent(cycleMonth)}` : ""
  }`;
export const getFp34AdditionalFeesUrl = (pharmacyId, cycleMonth) =>
  `/Finance/get-fp34-additional-fees?pharmacyId=${pharmacyId}${
    cycleMonth ? `&cycleMonth=${encodeURIComponent(cycleMonth)}` : ""
  }`;
export const addEndorsementUrl = (pharmacyId) =>
  `/Claims/add-endorsement?pharmacyId=${pharmacyId}`;
export const addUpdateExemptionUrl = (pharmacyId) =>
  `/Claims/add-update-exemption?pharmacyId=${pharmacyId}`;
export const getExemptionUrl = (pharmacyId, prescriptionId) =>
  `/Claims/get-exemption?pharmacyId=${pharmacyId}&prescriptionId=${prescriptionId}`;
export const getExpiringItemsUrl = (pharmacyId) =>
  `/ExpiringItems/get-expiring-items?pharmacyId=${pharmacyId}`;
export const bulkExemptionUrl = (pharmacyId) =>
  `/Claims/bulk-exemption?pharmacyId=${pharmacyId}`;
export const bulkClearClaimsUrl = (pharmacyId) =>
  `/Claims/bulk-clear-claims?pharmacyId=${pharmacyId}`;
export const saveClaimPrescriptionItemsUrl = (pharmacyId) =>
  `/Claims/save-claim-prescription-items?pharmacyId=${pharmacyId}`;
export const getClaimPrescriptionItemsUrl = (pharmacyId, prescriptionId) =>
  `/Claims/get-claim-prescription-items?pharmacyId=${pharmacyId}&prescriptionId=${prescriptionId}`;
export const getConcessionPricesUrl = (pharmacyId) =>
  `/Claims/get-concession-prices?pharmacyId=${pharmacyId}`;
export const searchSurgeryUrl = () => `/Surgery/search-surgery`;
export const getSurgeryByIdUrl = (surgeryId) =>
  `/Surgery/get-surgery-by-id?surgeryId=${surgeryId}`;
export const getGpConnectAccessRecordStructuredUrl = (
  nhsNumber,
  requestingOdsCode,
) =>
  `/GPConnect/get-access-record-structured?nhsNumber=${nhsNumber}&requestingOdsCode=${requestingOdsCode}`;

export const parseAbpmReportUrl = () => `/Ai/abpm-parse-report`;
export const updatePatientSurgeryUrl = () => `/Patient/update-patient-surgery`;

export const getGroupModeServicesUrl = (companyID) =>
  `/GroupMode/get-group-mode-services?companyID=${companyID}`;
export const addNhsServiceClaimUrl = () => `/Seeding/add-nhs-service-claim`;
export const getCompanyDocumentsByCompanyIdAndEmailUrl = (companyID) =>
  `CompanyDocument/get-company-document-by-email?companyID=${companyID}`;
export const addAndUpdateTaskEventUrl = (pharmacyId) =>
  `/ScheduleEvents/add-update-task?pharmacyID=${pharmacyId}`;
export const getBillingReportUrl = () => `/CompanyLedgers/get-billing-report`;
export const getBillingReportForBundlesUrl = () =>
  `/CompanyLedgers/get-billing-report-for-bundles`;
export const reinviteEmailToUserUrl = (memberId) =>
  `/Teams/re-invite-member?memberID=${memberId}`;

// #region Google Calendar URLs
export const getGoogleOAuthUrl = (pharmacyId = null, companyId = null) => {
  const params = new URLSearchParams();
  if (pharmacyId) {
    params.append("pharmacyId", pharmacyId);
  }
  if (companyId) {
    params.append("companyId", companyId);
  }
  const queryString = params.toString();
  return `/GoogleCalendar/oauth/url${queryString ? `?${queryString}` : ""}`;
};
export const getGoogleCalendarStatusUrl = () => `/GoogleCalendar/status`;
export const getGoogleCalendarsUrl = () => `/GoogleCalendar/calendars`;
export const triggerGoogleCalendarSyncUrl = (
  fullSync,
  pharmacyId,
  syncGoogleToTitanverse,
  companyId,
) =>
  `/GoogleCalendar/sync?companyId=${companyId}&pharmacyId=${pharmacyId}&fullSync=${fullSync}&syncGoogleToTitanverse=${syncGoogleToTitanverse}`;
export const syncAppointmentToGoogleUrl = (appointmentId) =>
  `/GoogleCalendar/sync/appointment/${appointmentId}`;
export const deleteAppointmentFromGoogleUrl = (appointmentId) =>
  `/GoogleCalendar/sync/appointment/${appointmentId}`;
export const disconnectGoogleCalendarUrl = () => `/GoogleCalendar/disconnect`;
// #endregion
export const addErrorLogUrl = () => `/ErrorLogs/add-error-log`;
